import * as yup from 'yup';
import { alphabetRegix, alphaNumericSpecialCharacterRegix, arabicNumericSpecialCharacterRegix, numericRegix, numericWithDecimalRegix, urlReg } from '../utils/functions';

export const general_information_schema = {
  commercialRegistrationNameEn: '',
  commercialRegistrationName: '',
  commercialRegistrationNo: '',
  expiryDateOfCR: '',
  expiryDateOfCRGRG: '',
  unifiedNumber: '',
  countryOfRegistration: '',
  dateOfIncorporation: '',
  dateOfIncorporationGRG: '',
  countryOfPracticingBusiness: '',
  paidUpCapital: '',
  annualTurnover: '',
  mainActivity: '',
  noOfEmployees: '',
  website: '',
  legalStructure: '',
  sharePersonList: [
    {
      name: '',
      percentageOwnership: '',
      birthPlace: '',
      idNumber: '',
    },
  ],
  managerList: [
    {
      name: '',
      position: '',
    },
  ],
  is_ksa:false
};

export const lettersOnly = /^[A-Za-z\s]+$/;
export const digitsOnly = /^[0-9]+$/;
export const alphaNumeric = /^(?! )[A-Za-z\d ]+(?<! )$/;
export const decimalNumber = /^\d{1,15}(\.\d{1,2})?$/;

export const general_information_validation_schema = yup.object().shape({
  commercialRegistrationNameEn: yup
    .string()
    .required('name_is_required')
    .matches(alphaNumericSpecialCharacterRegix, 'must_be_alphanumeric')
    .min(3, 'min_3_characters'),
  commercialRegistrationName: yup.string().when('isksa', {
    is: (val) => val === true,
    then: (schema) => schema.required('arabic_name_is_required').min(3, 'min_3_characters'),
    otherwise: (schema) => schema.notRequired(),
  }).matches(arabicNumericSpecialCharacterRegix, 'must_be_arabic'),

  expiryDateOfCRGRG: yup.string().required('expiry_date_required'),
  expiryDateOfCR: yup.string().required('expiry_hijri_date_required'),
  dateOfIncorporation: yup.string().required('incorporarion_date_required'),
  dateOfIncorporationGRG: yup
    .string()
    .required('incorporarion_hijri_date_required'),
  commercialRegistrationNo: yup
    .string()
    .required('commercial_registration_is_required')
    .min(10, 'min_10_characters')
    .max(15, 'max_15_characters')
    .matches(numericRegix, 'commercial_registration_must_be_numeric'),

  unifiedNumber: yup
    .string()
    .required('unified_number_is_required')
    .matches(numericRegix, 'unified_no_must_be_numeric'),

  countryOfRegistration: yup
    .object()
    .required('country_of_registration_is_required'),
  countryOfPracticingBusiness: yup
    .object()
    .required('country_of_practicing_is_required'),

  paidUpCapital: yup
    .string()
    .required('paid_up_capital_is_required')
    .matches(numericRegix, 'paid_up_capital_must_be_numeric'),

  annualTurnover: yup.string().required('annual_turnover_is_required'),
  noOfEmployees: yup
    .string()
    .required('no_of_employees_is_required')
    .min(1, 'no_of_employees_min_1')
    .matches(numericRegix, 'no_of_employees_must_be_numeric'),

  mainActivity: yup
    .string()
    .max(500, 'max_length_200')
    .required('main_business_en_is_required'),

  website: yup
    .string()
    .matches(urlReg, 'must_be_valid_url'),

  legalStructure: yup.string().required('legal_structure_is_required'),
  legalStructureOther: yup.string().when('legalStructure', {
    is: (val) => Number(val) === 1088,
    then: (schema) => schema.required('please_specify'),
    otherwise: (schema) => schema.notRequired(),
  }),
});
export const general_information_sharePersonList_validation_schema = yup
  .object()
  .shape({
    name: yup.string().required('name_is_required'),

    percentageOwnership: yup
      .string()
      .required('percentage_ownership_is_required')
      .matches(numericWithDecimalRegix, 'invalid_percentage')
      .test('max-100', 'max_100', (value) => parseFloat(value || '0') <= 100),

    birthPlace: yup
      .string()
      .required('birth_place_is_required')
      .matches(alphabetRegix, 'birth_place_must_be_alphabetic'),

    idNumber: yup
      .string()
      .required('id_number_required')
      .matches(numericRegix, 'id_number_must_be_numeric'),
  });

export const general_information_managerList_validation_schema = yup
  .object()
  .shape({
    name: yup
      .string()
      .required('name_is_required')
      .matches(alphabetRegix, 'must_be_alphabetic'),
    position: yup
      .string()
      .required('position_required')
      .matches(alphabetRegix, 'must_be_alphabetic'),
  });
